// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import donationDonorEntity from './entities/donation-donor.json';
import donationDonorMenu from '../pages/donation-donor/menu.json';
import donationDonorFullForm from '../pages/donation-donor/forms/full.json';
import donationDonorContextForm from '../pages/donation-donor/forms/context.json';
import donationDonorMiniForm from '../pages/donation-donor/forms/mini.json';
import donationDonorLookupForm from '../pages/donation-donor/forms/lookup.json';
import donationDonorTableView from '../pages/donation-donor/views/table.json';
import donationDonorCardsView from '../pages/donation-donor/views/cards.json';
import donationDonorDashboardView from '../pages/donation-donor/views/dashboard.json';

/** Тип запису «Донор» зі сторінками пакета: меню, форми та подання з pages/donation-donor/. */
export const donationDonorDefinition: IRecordTypeDefinition = {
  ...donationDonorEntity,
  views: assembleViewSet({
      table: donationDonorTableView,
      cards: donationDonorCardsView,
      dashboard: donationDonorDashboardView,
  }),
  form: donationDonorFullForm,
  forms: { full: donationDonorFullForm, context: donationDonorContextForm, mini: donationDonorMiniForm, lookup: donationDonorLookupForm },
  menu: donationDonorMenu,
} as IRecordTypeDefinition;
